export const ON_SUCCESS = 'onSuccess';
export const ON_ERROR = 'onError';
export const ON_START = 'onStart';
